/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Bulk_Delete_Title_OneInputs */

const en_recipes_bulk_delete_title_one = /** @type {(inputs: Recipes_Bulk_Delete_Title_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete 1 recipe?`)
};

const de_recipes_bulk_delete_title_one = /** @type {(inputs: Recipes_Bulk_Delete_Title_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Rezept löschen?`)
};

/**
* | output |
* | --- |
* | "Delete 1 recipe?" |
*
* @param {Recipes_Bulk_Delete_Title_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_bulk_delete_title_one = /** @type {((inputs?: Recipes_Bulk_Delete_Title_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Bulk_Delete_Title_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_bulk_delete_title_one(inputs)
	return en_recipes_bulk_delete_title_one(inputs)
});